module.exports = __webpack_public_path__ + "static/media/campaign2.be8cd37a.jpg";